module.exports = __webpack_public_path__ + "static/publicity-1-63b460ca1bbb3c6c1256ebe049495046.jpg";